import { Dispatch } from 'redux';

import { post, RequestExceptionWithResponse } from '@eika-infrastruktur/request';

import CustomAppTypes from '../config/customAppTypes';
import { AppState } from '../reducers';
import { errorNames } from '../util/mappings/errorName';
import { customFailed } from '../util/navUtil';
import { getRequestHeaders } from './tools';
import { actionTypes, AppActions } from './types';

type Action<T> = import('./types').Action<T>;
type FetchAgriMemberResponse = import('../generated-types').Agricard;

export interface FetchAgriMemberStartedAction extends Action<typeof actionTypes.FETCH_AGRI_MEMBER_STARTED> {
    type: typeof actionTypes.FETCH_AGRI_MEMBER_STARTED;
}

export interface FetchAgriMemberFulfilledAction extends Action<typeof actionTypes.FETCH_AGRI_MEMBER_FULFILLED> {
    type: typeof actionTypes.FETCH_AGRI_MEMBER_FULFILLED;
    payload: FetchAgriMemberResponse;
}

export interface FetchAgriMemberFailedAction extends Action<typeof actionTypes.FETCH_AGRI_MEMBER_FAILED> {
    type: typeof actionTypes.FETCH_AGRI_MEMBER_FAILED;
    payload: RequestExceptionWithResponse;
}

export type AgriActions = FetchAgriMemberStartedAction | FetchAgriMemberFulfilledAction | FetchAgriMemberFailedAction;

export const fetchAgriMemberStarted = (): FetchAgriMemberStartedAction => ({
    type: actionTypes.FETCH_AGRI_MEMBER_STARTED,
});
export const fetchAgriMemberFulfilled = (json: FetchAgriMemberResponse): FetchAgriMemberFulfilledAction => ({
    type: actionTypes.FETCH_AGRI_MEMBER_FULFILLED,
    payload: json,
});
export const fetchAgriMemberFailed = (error: RequestExceptionWithResponse): FetchAgriMemberFailedAction => ({
    type: actionTypes.FETCH_AGRI_MEMBER_FAILED,
    payload: error,
});

export const fetchAgriMember = async (dispatch: Dispatch<AppActions>, getState: () => AppState): Promise<void> => {
    const { loader, context, application } = getState();
    const { hasFetchedAgriMember, isFetchingAgriMember } = loader;
    const { agricardHash } = application.custom;
    if (CustomAppTypes.isAgri(context) && !hasFetchedAgriMember && !isFetchingAgriMember) {
        try {
            dispatch(fetchAgriMemberStarted());
            const response: FetchAgriMemberResponse = await post(
                `${actionTypes.RESOURCE_PATH}/agricard/autentiser`,
                agricardHash,
                getRequestHeaders(context.config.bankregnr),
            );

            if (application.custom.agricardHash === '' && context.appType === 'agricard') {
                dispatch(fetchAgriMemberFailed(customFailed(errorNames.agriTokenValidFailed)));
            }
            dispatch(fetchAgriMemberFulfilled(response));
        } catch (error) {
            dispatch(fetchAgriMemberFailed(error));
        }
    }
};
